import React from 'react'

function TextCell({ value }) {
  const shouldWrap = value && value.length > 64
  const shouldTruncate = value && value.length > 256
  const displayValue = shouldTruncate ? value.substring(0, 253) + '...' : value

  return (
    <td
      className="align-middle text-muted fw-light"
      style={shouldWrap ? {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '300px'
      } : {}}
      title={shouldTruncate ? value : undefined}
    >
      {displayValue}
    </td>
  )
}

export default TextCell